// Importer le nouveau dashboard split
import { SupportDashboardSplit } from "./SupportDashboardSplit";

export const SupportDashboard: React.FC = () => {
  // Utiliser le nouveau layout split
  return <SupportDashboardSplit />;
};
